var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArticleCategory = function SvgArticleCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0C141B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.984,
    d: "M3.16 17.152V4.512c0-.997.807-1.805 1.805-1.805H16.7c.998 0 1.806.808 1.806 1.805v9.028c0 .997-.808 1.805-1.806 1.805H4.965a1.805 1.805 0 1 0 0 3.61H16.7c.998.001 1.806-.807 1.806-1.805v-4.513M14.895 6.912H6.77M14.895 10.833H6.77"
  })));
};
export { SvgArticleCategory as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNGUxNzExZjdjNTkyYTEwNmUzNGQwMzdmNjExYTU2MTUuc3ZnIjs=";